<template>
  <div class="records-wrapper">
    <van-nav-bar title placeholder fixed :left-arrow="typeNav == 1">
      <template #left v-if="typeNav == 1">
        <van-icon name="arrow-left" color="#272727" size="18" @click="onClickLeft" />
      </template>
      <template #title>
        <div style="color: #272727">客户服务</div>
      </template>
      <template #right v-if="typeNav != 1">
        <van-icon name="cross" color="#272727" size="18" @click="onClickRight" />
      </template>
    </van-nav-bar>
    <div class="customer-wrappper">
      <div class="customer-item" v-for="item in serviceList" :key="item.id" @click="handleClick(item)">
        <img src="@/assets/images/customerService/w.png" v-if="item.type == 1" class="customer-icon">
        <img src="@/assets/images/customerService/t.png" v-else-if="item.type == 2" class="customer-icon">
        <img src="@/assets/images/customerService/cs-1.png" v-else-if="item.type == 3" class="customer-icon">
        <img src="@/assets/images/customerService/cs-2.png" v-else-if="item.type == 4" class="customer-icon">
        <div>{{ item.serviceName }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSocket } from "@/utils/webSocket";
import { getCustomerServiceList } from '@/api/customerService.js'
export default {
name: "CustomerService",
  data(){
    return {
      serviceList: [],
      type: '0'
    }
  },
  props: {
    typeNav: {
      type: Number,
      default: 1
    }
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    onClickRight() {
      this.$emit('close')
    },
    async getCustomerServiceList () {
      const resp = await getCustomerServiceList()
      if (this.type == '1') {
        this.serviceList = resp.rows.filter(item => item.type != 3 || item.type != '3')
      } else {
        this.serviceList = resp.rows
      }
    },
    handleClick (item) {
      if (item.type == 1 || item.type == 2) {
        window.location.href = item.url
      }
      if (item.type == 3 || item.type == 4) {
        if (this.typeNav == 1) {
          this.$router.push('/chat')
        } else {
          this.$emit('close', true)
        }
      }
    }
  },
  mounted () {
    this.getCustomerServiceList()
    getSocket()
    // else {
    //   this.serviceList = [{
    //     id: 1,
    //     type: 2,
    //     serviceName: 'Customer Service',
    //     url: 'https://t.me/CS00005'
    //   }]
    // }
    this.type = this.$route.query.type
  }
}
</script>

<style scoped lang="scss">
.records-wrapper {
  background: #eee;
  min-height: 100vh;
}
.customer-wrappper {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  padding: 20px 0 0;
  .customer-item {
    width: 168px;
    background: #fff;
    border-radius: 6px;
    padding: 16px 0 16px;
    font-size: 12px;
    color: #333;
    font-weight: bold;
    text-align: center;
    margin: 0 10px 10px;
    .customer-icon {
      display: block;
      width: 58px;
      margin: 0 auto 20px;
    }
  }
}
</style>